import { QrCodeVisitStatus, QrCodeVisitWeb } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from './visitor';

export function generateMockQrCodeVisitWeb({
  id = 'mockQrCodeVisitWebId',
  name = 'mockQrCodeVisitWebName',
  datetime = 'mockQrCodeVisitWebDatetime',
  email,
  host = generateMockVisitor({}),
  status = QrCodeVisitStatus.Valid
}: Partial<Omit<QrCodeVisitWeb, '__typename'>>): QrCodeVisitWeb {
  return {
    __typename: 'QrCodeVisitWeb',
    id,
    name,
    datetime,
    email,
    host,
    status
  };
}
